import React, {Component} from 'react';
import styles from './styles.css';

export default class Link extends Component {
	render() {
		let {icon, className, ...props} = this.props;
		className = className ? className : '';
		className += ' ' + styles['bsui-link'];

		if (icon)
		{
			return <a className={className} {...props}>
				{icon}
				{' '}
				<span className={styles['bsui-link__text']}>{this.props.children}</span>
			</a>;
		}
		else
		{
			className += ' ' + styles['bsui-link_simple'];

			return <a className={className} {...props}>{this.props.children}</a>;
		}
	}
}